require('../../asset/style/style.scss');

const React = require('react');
const config = require('../../config');
const helper = require('../../helper/dish-helper.js');
const connect = require('react-redux').connect;
const actions = require('../../action/shop-list/shop-list-ts.js');
const ShopAll = require('../../component/shop-list/shop-all-ts.jsx');
const Toast = require('../../component/mui/toast.jsx');
const Loading = require('../../component/mui/loading.jsx');
const brandId = helper.getUrlParam('brandId');
const uniqueId = helper.getUrlParam('uniqueId');

const ShopListTSApplication = React.createClass({
  displayName: 'ShopListTSApplication',
  propTypes: {
    // reducer
    allNearShopList: React.PropTypes.object.isRequired,
    allShopList: React.PropTypes.object.isRequired,
    cityList: React.PropTypes.array.isRequired,
    load: React.PropTypes.object.isRequired,
    errorMessage: React.PropTypes.string.isRequired,
    yunChengSchoolFlag: React.PropTypes.bool,

    // action
    getAllShopList: React.PropTypes.func.isRequired,
    clearAllShopList: React.PropTypes.func.isRequired,
    getNearShopList: React.PropTypes.func.isRequired,
    getCityList: React.PropTypes.func.isRequired,
    clearNearShopList: React.PropTypes.func.isRequired,
    getCurLocation: React.PropTypes.func.isRequired,
    clearErrorMsg: React.PropTypes.func,
    getQueueInfo: React.PropTypes.func,
    setLoadMsg: React.PropTypes.func,
    setErrorMsg: React.PropTypes.func,
    getYCSAllShopList: React.PropTypes.func,
  },
  getInitialState() {
    return {
      address: '正在获取当前位置...',
      addressOk: -1,
      curAddressOk: true,
      childView: '',
      point: {},
      curPosition: {},
      nearShopNumber: 0,
      isGetLocSuccess: false,
    };
  },
  componentDidMount() {
    const $this = this;
    new Promise((resolve, reject) => {
      $this.props.getCityList(resolve);
    }).then(() => {
      this.firstLoad = true;
      this.getNearShopList();
    });
  },
  getNearShopList() {
    const { getCurLocation, getNearShopList, allNearShopList = {} } = this.props;

    const getNearShopListMethod = (curPosition, object) =>
      getNearShopList(curPosition, object, nearShopList => {
        const shopList = nearShopList.cList || [];
        // 从品牌页面过来并且只有一个门店的情况下,直接跳转点餐页面
        if (shopList.length === 0) {
          return;
        } else if (shopList.length === 1) {
          this.setState({ nearShopNumber: 1 }, () => {
            if (brandId) {
              if (uniqueId === 'TS') {
                location.href = `${config.dishMenu4DinnerURL}?shopId=${shopList[0].commercialID}&type=${uniqueId}&uniqueId=${uniqueId}`;
              }
            }
          });
        }
      });
    if (this.state.curPosition.city) {
      if (!allNearShopList.cList || (allNearShopList.cList && allNearShopList.cList.length === 0)) {
        getNearShopListMethod(this.state.curPosition, { pageNum: 1, keyWord: '' });
      }
      return;
    }
    getCurLocation((curPosition = {}, obj = {}) => {
      // 附近门店
      this.setState({
        curPosition,
        address: obj.address,
        addressOk: obj.addressOk, // 是否获取当前地址成功
        curAddressOk: obj.addressOk,
        point: { longitude: curPosition.longitude, latitude: curPosition.latitude },
      });
      getNearShopListMethod(curPosition, { pageNum: 1, keyWord: '' });
    });
  },

  compontentWillMount() {
    window.addEventListener('hashchange', this.setChildViewAccordingToHash);
    window.addEventListener('load', this.changeHash);
    localStorage.removeItem('basicListInfo');
    sessionStorage.removeItem('receiveOrderCustomerInfo');
  },
  render() {
    const { addressOk, curPosition } = this.state;
    // reducers
    const {
      allShopList,
      allNearShopList,
      cityList,
      load = {},
      getQueueInfo,
      getAllShopList,
      getNearShopList,
      clearAllShopList,
      clearNearShopList,
      setLoadMsg,
      errorMessage,
      clearErrorMsg,
      yunChengSchoolFlag, // YCS标志
      getYCSAllShopList, // YCS接口
      setErrorMsg,
    } = this.props;

    const curPos = {
      city: '',
      longitude: '',
      latitude: '',
      isGetLoc: false,
    };
    return (
      <div className="o-bg-grey o-flex o-flex--column">
        <ShopAll
          getAllShopList={getAllShopList}
          getNearShopList={getNearShopList}
          clearAllShopList={clearAllShopList}
          clearNearShopList={clearNearShopList}
          allNearShopList={allNearShopList}
          allShopList={allShopList}
          addressOk={addressOk}
          getQueueInfo={getQueueInfo}
          curPosition={addressOk ? curPosition : curPos}
          setLoadMsg={setLoadMsg}
          setErrorMsg={setErrorMsg}
          cityList={cityList}
          yunChengSchoolFlag={yunChengSchoolFlag} // YCS 标志
          getYCSAllShopList={getYCSAllShopList} // YCS数据请求
        />
        {load.status && <Loading word={load.word} />}
        {errorMessage && <Toast clearErrorMsg={clearErrorMsg} errorMessage={errorMessage} />}
      </div>
    );
  },
});

module.exports = connect(
  state => state,
  actions,
)(ShopListTSApplication);



// WEBPACK FOOTER //
// ./src/container/shop-list-ts/application.jsx